import React from "react";
import styled from "styled-components";
import { StaticQuery, graphql } from "gatsby";
import Components from "@components/Components";
import ContentfulPageSEO from "@components/ContentfulPageSEO";
import ContentfulModuleLightBox from "@components/ContentfulModuleLightBox";
import { useLightboxContext } from "@hooks";

const StyledContainer = styled.div`
  margin: auto;
  max-width: 100%;
  height: 100vh;
`;

const ContentfulAllModules = ({ block }) => {
  const { lightboxContext } = useLightboxContext();

  const renderLightBox = () =>
    lightboxContext && <ContentfulModuleLightBox content={lightboxContext} />;

  return (
    <StaticQuery
      query={graphql`
        query allSiteQuery {
          allContentfulPageCombined {
            edges {
              node {
                name
                contentful_id
                modules {
                  ... on ContentfulModuleHeader {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleImageText {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleContentOverBackgroundImage {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleText {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleLinkList {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleTextList {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleForm {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleImage {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleFaq {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleFooter {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleCallToAction {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleImageTextCarousel {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleImageTextCarousel {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleTitleTextCallToAction {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleTestimonial {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleVideoEmbedded {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModulePlan {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleFaq {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleIframe {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleIconRichTextList {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleCounter {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleTextTiles {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleUsp {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModulePromotionBlock {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleLogos {
                    contentful_id
                    internal {
                      type
                    }
                  }
                  ... on ContentfulModuleTable {
                    contentful_id
                    internal {
                      type
                    }
                  }
                }
                pageMeta {
                  title
                  author
                  description {
                    description
                  }
                  ogtitle
                  ogdescription {
                    ogdescription
                  }
                  ogurl {
                    ogurl
                  }
                  ogtitle
                  oglocale
                  ogimageMedia {
                    localFile {
                      url
                    }
                  }
                  ogimage {
                    ogimage
                  }
                  ogtype
                }
              }
            }
          }
        }
      `}
      render={data => {
        const page =
          block &&
          data &&
          data.allContentfulPageCombined &&
          data.allContentfulPageCombined.edges &&
          data.allContentfulPageCombined.edges.length > 0 &&
          data.allContentfulPageCombined.edges.filter(
            item => item.node.contentful_id === block.contentful_id
          )[0];

        const meta = page && page.node && page.node.pageMeta;
        const listOfModules = page && page.node && page.node.modules;

        return (
          <>
            {listOfModules && listOfModules.length > 0 && (
              <StyledContainer>
                <ContentfulPageSEO meta={meta} />
                {listOfModules.map(block => Components(block))}
                {renderLightBox()}
              </StyledContainer>
            )}
          </>
        );
      }}
    />
  );
};

export default ContentfulAllModules;
